import type { HelpFile } from '../../types/help'
import { ProvisioningTaskDetailTestIds } from '../../../testids/ProvisioningTaskDetailTestIds'

export const provisioningTaskDetailHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-tasks',
  texts: {
    [ProvisioningTaskDetailTestIds.taskDetailTitle]: null,
    [ProvisioningTaskDetailTestIds.taskInfoCard]: 'Aufgabenübersicht — Identität, Aktion, Enforcement-Objekt und Zielsystem.',
    [ProvisioningTaskDetailTestIds.errorCard]: 'Fehlerdetails einer fehlgeschlagenen Provisionierungs-Aufgabe — Fehlermeldung und Link zum vollständigen Fehlerprotokolleintrag.',
    [ProvisioningTaskDetailTestIds.timelineCard]: 'Statusverlauf — von der Aufgabenerstellung bis zum Abschluss oder Fehlschlag.',
    [ProvisioningTaskDetailTestIds.timelineEntries]: null,
    [ProvisioningTaskDetailTestIds.statusBadge]: null,
    [ProvisioningTaskDetailTestIds.errorMessage]: null,
    [ProvisioningTaskDetailTestIds.errorLogLink]: null,
    [ProvisioningTaskDetailTestIds.linkIdentity]: null,
    [ProvisioningTaskDetailTestIds.linkTargetSystem]: null,
    [ProvisioningTaskDetailTestIds.btnRetryTask]:
      'Diese Provisionierungs-Aufgabe erneut einreihen. Die Aufgabe wird auf "ausstehend" zurückgesetzt und beim nächsten Lauf des Konnektors erneut versucht.',
    [ProvisioningTaskDetailTestIds.nextRetryAt]: 'Geplanter Zeitpunkt des nächsten automatischen Wiederholungsversuchs. Wird nur angezeigt, solange die Aufgabe ihr Backoff-Fenster abwartet.',
  },
}
